import React from 'react';
import { Link } from 'react-router-dom';
import { CellContainer, Cell, Row, CellDate } from '@bit/knotchinc.web-react-components.table-sync';
import EntityIconList from 'components/Global/EntityIconList/EntityIconList.jsx';
// import KeywordSearchLink from 'components/Global/Tag/KeywordSearchLink.jsx';
import { formatDate } from 'helpers/Utils.js';
import { TitleText, ReportLink, SubtitleText } from './styled';

export const ReportRow = props => {
  let dateRange;
  let title;
  let brands;
  let publishers;
  let isBrand;
  let id;
  let subtitle;

  if (!props.header && props.data) {
    brands = props.data.brands;
    publishers = props.data.publishers;
    dateRange = `${formatDate(props.data.start_date, { short: true })} - ${formatDate(props.data.end_date, { short: true })}`;
    title = props.data.title || `${props.data.frequency} Report - ${dateRange}`;
    subtitle = `${props.data.account_name ? `${props.data.account_name} - ` : ''}${props.data.email}`;
    isBrand = props.data.report_type === 'brand';
    id = props.data.public_id;
    // keywords = props.data.keywords.map((keyword, i) => <KeywordSearchLink key={`${keyword}_${props.data.title}_${i}`} data={keyword} />);
  }

  return (<Row {...props}>
    <CellContainer headerText="Title" width={0.21}>
      <TitleText>
        {title}
      </TitleText>
      {props.isKnotchAdmin && <SubtitleText>
        {subtitle}
      </SubtitleText>}
    </CellContainer>
    <CellDate type="created_at" headerText="Date Generated" width={0.12} />
    <Cell type="report_type" headerText="Report Type" width={0.1} />
    <Cell data={dateRange} headerText="Dates" width={0.17} />
    {/* <Cell type="content_type" headerText="Content" width={0.07} /> */}
    <CellContainer headerText="Competitors" width={0.2}>
      {isBrand ?
        <EntityIconList
          type="brand"
          data={brands}
        /> :
        <EntityIconList
          type="publisher"
          data={publishers}
        />}
    </CellContainer>
    {/* <CellContainer headerText="Keywords" width={0.16}>
      <KeywordsContainer>
        {keywords}
      </KeywordsContainer>
    </CellContainer> */}
    <CellContainer width={0.2}>
      <ReportLink as={Link} to={`/blueprint/reports/${id}`}>
        VIEW REPORT
      </ReportLink>
    </CellContainer>
    {/* <CellContainer width={0.05}>
      <DownloadLink />
    </CellContainer> */}
  </Row>);
};
